export default "__VITE_ASSET__BBoN$PRu__"